// extracted by extract-css-chunks-webpack-plugin
module.exports = {"eventCardGrid":"_14HbKX","card":"_32qH8R"};